let _particleCssLoaded = false;

export default async function useLoadParticleCss(): Promise<boolean> {
  if (!import.meta.client) return false;

  if (_particleCssLoaded) return true;

  try {
    await import("~/assets/css/particleEffect.css");
    await import("~/assets/css/lazyPriority.css");

    _particleCssLoaded = true;
    return true;
  } catch (e) {
    console.error("Failed to load particleEffect.css dynamically", e);
    return false;
  }
}
